module.exports = __webpack_public_path__ + "img/google-logo.10c25a60.svg";